module.exports = __webpack_public_path__ + "img/logo__country_oak_estates--light.312ab7c7.webp";